module.exports = __webpack_public_path__ + "static/media/jhon_and_george.b3ed3492.jpg";